import { render, staticRenderFns } from "./IdentifyRecord.vue?vue&type=template&id=21a2d9e8&"
import script from "./IdentifyRecord.vue?vue&type=script&lang=js&"
export * from "./IdentifyRecord.vue?vue&type=script&lang=js&"
import style0 from "./IdentifyRecord.vue?vue&type=style&index=0&id=21a2d9e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports